{
  "allWeb3Coins": "جميع عملات Web3",
  "approvalPending": "الموافقة قيد التنفيذ...",
  "assets": "الأصول",
  "bnbBalance": "رصيد BNB",
  "bnbSendFailed": "فشل إرسال BNB",
  "bnbSentSuccessfully": "تم إرسال BNB بنجاح",
  "clearHistory": "مسح السجل",
  "clearHistoryConfirm": "هل تريد حذف سجل المعاملات بالكامل؟",
  "connectWallet": "ربط المحفظة",
  "connectWalletFirst": "قم بتوصيل المحفظة أولاً",
  "connectWeb3Wallet": "ربط محفظة Web3",
  "copyAddressReceive": "نسخ العنوان / الاستلام",
  "disconnect": "فصل",
  "enterAmount": "أدخل المبلغ",
  "fromCoin": "من العملة",
  "history": "السجل",
  "installWallet": "يرجى تثبيت MetaMask أو Trust Wallet",
  "insufficientBnbGas": "لا يوجد رصيد BNB كافٍ. احتفظ بما لا يقل عن 0.01 BNB لرسوم الغاز.",
  "loading": "جاري التحميل...",
  "noNewReceiveTransaction": "لا توجد معاملة استلام جديدة",
  "noTransactionsYet": "لا توجد معاملات حتى الآن",
  "processing": "جاري المعالجة...",
  "receive": "استلام",
  "receiveCrypto": "استلام العملات الرقمية",
  "receiveTransactionSynced": "تمت مزامنة معاملة الاستلام",
  "receiverAddress": "عنوان المستلم",
  "refreshBalance": "تحديث الرصيد",
  "searchCoin": "ابحث عن عملة...",
  "searchTransaction": "ابحث في المعاملات...",
  "send": "إرسال",
  "sendNow": "إرسال الآن",
  "serverError": "خطأ في الخادم.",
  "sessionExpired": "انتهت الجلسة. الرجاء تسجيل الدخول مرة أخرى.",
  "swap": "مبادلة",
  "swapCompleted": "اكتملت المبادلة",
  "swapFailed": "فشلت المبادلة",
  "swapNow": "ابدأ المبادلة",
  "swapPending": "المبادلة قيد التنفيذ...",
  "swapTrade": "مبادلة / تداول",
  "syncHistory": "مزامنة السجل",
  "syncReceive": "مزامنة الاستلام",
  "toCoin": "إلى العملة",
  "tokenSwapRouteSoon": "سيتم دعم مبادلة العملات قريباً",
  "totalAssets": "إجمالي الأصول",
  "transactionConfirmed": "تم تأكيد المعاملة",
  "transactionHistory": "سجل المعاملات",
  "transactionPending": "المعاملة قيد التنفيذ...",
  "viewOnBscScan": "عرض على BscScan",
  "walletAddress": "عنوان المحفظة",
  "walletAddressCopied": "تم نسخ عنوان المحفظة",
  "walletAppNotFound": "لم يتم العثور على MetaMask / Trust Wallet",
  "walletConnected": "تم ربط المحفظة بنجاح",
  "walletConnectionFailed": "فشل ربط المحفظة",
  "walletDisconnected": "تم فصل المحفظة",
  "walletNotFound": "المحفظة غير موجودة",
  "web3Wallet": "محفظة Exalt Exchange Web3",
  "web3WalletSubtitle": "MetaMask / Trust Wallet الآمنة • BNB Smart Chain • محفظة EXALT"
}